export default {
  header: 'Taste',
};
